exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.password-success[data-v-62e1031a] {\n  font-weight: 500;\n  text-align: center;\n}\n.changed-title[data-v-62e1031a] {\n  font-size: 40px;\n  line-height: 48px;\n  letter-spacing: -0.72px;\n  color: #131c36;\n}\n.changed-router-links[data-v-62e1031a] {\n  font-size: 18px;\n}\n.changed-undertitle[data-v-62e1031a] {\n  font-size: 18px;\n  line-height: 24px;\n  color: #3e475e;\n  margin-top: 7px;\n  margin-bottom: 43px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62e1031a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/SetNewPasswordSuccess.vue
// module id = ne79
// module chunks = 0